export default "__VITE_ASSET__zhPKq4MM__"